// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import pconfEntity from './entities/pconf.json';
import pconfMenu from '../pages/pconf/menu.json';
import pconfFullForm from '../pages/pconf/forms/full.json';
import pconfContextForm from '../pages/pconf/forms/context.json';
import pconfMiniForm from '../pages/pconf/forms/mini.json';
import pconfLookupForm from '../pages/pconf/forms/lookup.json';
import pconfTableView from '../pages/pconf/views/table.json';
import pconfStagesView from '../pages/pconf/views/stages.json';
import pconfCardsView from '../pages/pconf/views/cards.json';
import pconfInlineView from '../pages/pconf/views/inline.json';
import pconfBacklogView from '../pages/pconf/views/backlog.json';
import pconfSplitView from '../pages/pconf/views/split.json';
import pconfCalendarView from '../pages/pconf/views/calendar.json';
import pconfDashboardView from '../pages/pconf/views/dashboard.json';

/** Тип запису «Конфлікт» зі сторінками пакета: меню, форми та подання з pages/pconf/. */
export const pconfDefinition: IRecordTypeDefinition = {
  ...pconfEntity,
  views: assembleViewSet({
      table: pconfTableView,
      stages: pconfStagesView,
      cards: pconfCardsView,
      inline: pconfInlineView,
      backlog: pconfBacklogView,
      split: pconfSplitView,
      calendar: pconfCalendarView,
      dashboard: pconfDashboardView,
  }),
  form: pconfFullForm,
  forms: { full: pconfFullForm, context: pconfContextForm, mini: pconfMiniForm, lookup: pconfLookupForm },
  menu: pconfMenu,
} as IRecordTypeDefinition;
